import React from 'react';
import { Link } from 'react-router-dom';
import useDataSaver from '../../hooks/useDataSaver';
import Icon from '../common/Icon';

const styles = {
  ImageContainer: {
    borderRadius: '8px',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    backgroundColor: 'white',
  },
};

const Image = ({
  url = require('./../../assets/images/fallback/user.png'),
  reload = false, // if true, force reload on every page load
  size = '10rem',
  to = null,
  children,
  className,
  onClick,
  contain = false,
  isSquare = true,
  style = {},
}) => {
  const dataSaver = useDataSaver();

  // Append a timestamp query parameter if reload is true
  const safeUrl = url || '';
  const finalUrl = reload
    ? `${safeUrl.includes(' ') ? encodeURI(safeUrl) : safeUrl}?reload=${Date.now()}`
    : (safeUrl.includes(' ') ? encodeURI(safeUrl) : safeUrl);

  const imageStyle = {
    ...styles.ImageContainer,
    ...style,
    // In data-saver mode, omit the background-image entirely so the browser
    // never fetches it, and show a neutral grey box instead.
    backgroundImage: dataSaver ? 'none' : `url(${finalUrl})`,
    backgroundSize: contain ? 'contain' : 'cover',
    ...(dataSaver ? { backgroundColor: '#dfe3e6' } : {}),
  };

  if (isSquare) {
    imageStyle.width = size;
    imageStyle.height = size;
  }

  const image = (
    <div style={imageStyle} className={className} onClick={onClick}>
      {dataSaver && (
        <Icon
          name="picture"
          theme="muted"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            opacity: 0.4,
            color: '#6b7280',
            pointerEvents: 'none',
          }}
        />
      )}
      {children}
    </div>
  );

  return to ? (
    <Link to={to} className="link">
      {image}
    </Link>
  ) : (
    image
  );
};

export default Image;
